import { Link } from "react-router-dom";
import { useLang } from "../context/LangContext";

export default function NotFound() {
  const { t, path } = useLang();
  return (
    <div className="min-h-screen bg-ink flex flex-col items-center justify-center text-center px-6">
      <div className="font-serif text-8xl text-gold/40">404</div>
      <p className="text-sand mt-6 mb-10">Página não encontrada · Page not found</p>
      <Link to={path("home")} className="btn-gold btn-caps">{t.common.backHome}</Link>
    </div>
  );
}
